export type PreviewPage = {
  src: string;
  alt: string;
};

export const previewPages: PreviewPage[] = [
  {
    src: 'https://cdn.magicpatterns.com/uploads/8aqE5tDps78D9mJumZW8XF/IMG_2696.jpg',
    alt: 'Sample page From Raw Materials to Industrial Products, showing six stages from raw material acquisition to storage and distribution',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/rKMZ3KTiH7LTptf3ddTaUu/IMG_2697.jpg',
    alt: 'Sample page How a Chemical Manufacturing System Works, from feedstock preparation to waste and emissions management',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/2FBqXAvZxif5knsKhkTT7S/IMG_2698.jpg',
    alt: 'Sample page Energy, Phases & the Direction of Chemical Change, explaining open and closed thermodynamic systems',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/7YE6y63uGxKwA7iiYRPqCz/IMG_2699.jpg',
    alt: 'Sample page Example: Combining Two Liquid Streams, a worked steady-state material balance resulting in 2% salt by mass',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/n3XT3PqiWhg2zjTRrC25wo/IMG_2700.jpg',
    alt: 'Sample page From Geological Resources to Industrial Chemicals, covering limestone, sodium chloride, phosphate rock, sulfur and silica',
  },
];
